var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 95,
    viewBox: "0 0 114 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4535207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4534801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.5218 86.9454C80.0898 91.3441 101.14 77.4256 105.539 55.8575C109.937 34.2894 96.0189 13.2392 74.4509 8.84053C52.8828 4.44183 31.8326 18.3603 27.4339 39.9284C23.0352 61.4965 36.9537 82.5467 58.5218 86.9454Z",
    fill: "#C07C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.5482 47.2491C44.7632 48.1087 48.877 45.3886 49.7367 41.1736C50.5963 36.9586 47.8762 32.8448 43.6612 31.9852C39.4462 31.1256 35.3324 33.8456 34.4728 38.0606C33.6132 42.2756 36.3332 46.3894 40.5482 47.2491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M67.5106 39.5049C71.7256 40.3645 75.8394 37.6445 76.6991 33.4295C77.5587 29.2145 74.8386 25.1007 70.6236 24.2411C66.4086 23.3814 62.2948 26.1015 61.4352 30.3165C60.5756 34.5315 63.2956 38.6453 67.5106 39.5049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.8336 33.3935C73.2269 30.6211 72.1088 27.2441 69.3364 25.8508C66.5639 24.4576 63.1869 25.5757 61.7937 28.3481C60.4004 31.1206 61.5185 34.4975 64.2909 35.8908C67.0634 37.284 70.4403 36.166 71.8336 33.3935Z",
    fill: "#D79B7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.8623 41.3727C46.2674 38.5873 45.1483 35.1903 42.3629 33.7853C39.5774 32.3802 36.1803 33.4992 34.7753 36.2847C33.3703 39.0701 34.4894 42.4672 37.2748 43.8722C40.0603 45.2773 43.4573 44.1582 44.8623 41.3727Z",
    fill: "#D79B7A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2800_630)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.5505 8.53119C10.5814 8.22384 10.6028 7.95688 10.6365 7.6922C10.8181 6.28501 11.348 5.03667 12.34 4.02003C13.2785 3.06175 14.5249 2.46683 15.8632 2.33822C17.2016 2.20962 18.5478 2.55544 19.6687 3.31582C21.4904 4.54259 22.4186 6.29682 22.6481 8.45114C22.8523 10.3629 22.6047 12.2332 22.1974 14.0877C21.7636 16.0614 21.1306 17.9706 20.3848 19.8444C19.913 21.025 19.0418 21.6394 17.7679 21.6677C14.9932 21.7313 12.2312 21.5976 9.5082 20.9666C7.98398 20.6133 6.51981 20.1 5.20679 19.2071C2.87813 17.623 1.80442 14.72 2.60667 12.136C2.92371 11.0854 3.5466 10.1569 4.39574 9.46922C6.12878 8.05352 8.08731 7.85223 10.1985 8.43028C10.3043 8.46147 10.4075 8.49121 10.5505 8.53119Z",
    fill: "#D8565B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2800_630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8549,
    height: 18.2124,
    fill: "white",
    transform: "translate(0 12.4941) rotate(-34.8668)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaHeartIcon);
export default __webpack_public_path__ + "static/media/boba-heart-icon.b6dc4a8f.svg";
export { ForwardRef as ReactComponent };